export default {
  toolbar: 'tab-bar',
  toolbarHide: 'hide',
  toolbarPrevItem: 'prev',
  toolbarRefreshItem: 'refresh',
  toolbarTabWrapperItem: 'scroll',
  toolbarNextItem: 'next',
  toolbarDropdownItem: 'dropdown',
  toolbarFullscreenItem: 'fullscreen',
  tabBody: 'tab-body',

  tabActive: 'active',
  tabDisabled: 'disabled',
  tabPaneActive: 'active',
  //关闭按钮鼠标移入时才显示时的辅助类名
  showCloseBtnOnHover: 'hover',
  listGroupCloseItem: 'close',

  listGroupActive: 'active',
  listGroupCloseOtherItem: 'other',
  listGroupClosePrevItem: 'prev',
  listGroupCloseNextItem: 'next',
  listGroupCloseAllItem: 'all',
  listGroupRefreshItem: 'refresh',
  listGroupCenterActiveItem: 'center-active',
  listGroupNewBlankItem: 'new-blank',
  listGroupFullscreenItem: 'fullscreen',
  //遮罩层
  overlays: 'mask',

  //下拉菜单粘性标题部分有图标时的类
  dropdownBodyStickyHasIcon: 'has-icon',

  //用于阻止事件被iframe无视的问题(增强用户体验)
  contextmenuPEN: 'pen-contextmenu',
  dropdownPEN: 'pen-dropdown',

  dropdownActive: 'active',
}
